import HorizontalImageCard from "../elements/horizontalImageCard";


export default function CarouselCard14() {

    return (
        <div className="flex">

            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 md:w-full mx-12">
                    <div className="swiper-slide card-slide card-slide-left  ">

                        <HorizontalImageCard
                            imageURL="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2Frachelcrop.jpg.webp?alt=media&token=3f50a807-a137-4b57-93be-25d2bfffa01f"
                            imageAlt="Extern Academy Alumni"
                            title="Extern Academy Alumni"
                            blurb="Our alumni are
                                    true global
                                    citizens. While
                                    making their
                                    mark on their
                                    world, they
                                    always find
                                    themselves back
                                    on familiar turf
                                    to pay it
                                    forward by
                                    lending their
                                    time and
                                    expertise to
                                    nurture the
                                    growth of
                                    current
                                    students."
                        />
                    </div>
                    <div className="swiper-slide card-slide card-slide-center  ">

                        <HorizontalImageCard
                            imageURL="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2FIMG_4216.jpg.webp?alt=media&token=888da198-ac98-4d4e-aefc-d185434ae4a7"
                            imageAlt="Extern Academy Co-Founder"
                            title="Extern Academy Co-Founder"
                            blurb="Extern Academy alumni
                                can be found
                                sparking
                                innovation in
                                tech hubs or
                                leading
                                grassroots
                                movements in
                                their
                                communities. But
                                no matter where
                                they are, our
                                alumni are not
                                afraid to shake
                                things up. They
                                go on to build
                                companies, drive
                                change, and open
                                doors for the
                                next generation."
                        />
                    </div>


                </div>

            </div>
        </div>
    )
}